module.exports = __webpack_public_path__ + "static/img/MN.b11abb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listings/states/MN.jpg
// module id = wavR
// module chunks = 0